import {createSvgIcon} from '@yandex-delivery/blocks/icons/utils'

export default createSvgIcon(
  <path d="M6.85971 7.01852L8.04489 0.5L0 9.98148H4.45342L2.87318 16.5L11.4927 7.01852H6.85971Z" fillRule="evenodd" />,
  'Surge',
  {
    viewBox: '0 0 12 17',
  },
)
